import type { Vendor } from "src/types";

export const CARD_HORIZONTAL_GAP = 12;
export const CARD_VERTICAL_GAP = 24;

export const DEFAULT_VENDORS: Vendor[] = [
  {
    id: 1,
    name: "Opensource",
    booth_size: "large",
    background_image: "/canvas/hazel/images/banner-1-placeholder.c3772d7f.jpg",
    image_url: "/canvas/hazel/images/logo-1-placeholder.1cd0f248.jpg",
    headline:
      "With opensource, companies all over the world share practices, knowledge and tools to drive sustainability initiatives in all industries.",
  },
  {
    id: 2,
    name: "Stage",
    booth_size: "large",
    background_image: "/canvas/hazel/images/banner-2-placeholder.3cc1a85e.jpg",
    image_url: "/canvas/hazel/images/logo-2-placeholder.07a99e7f.jpg",
    headline:
      "Stage is the platform for everyone who has something powerful to say and is looking to reach a wide audience, fast.",
  },
  {
    id: 3,
    name: "Acme Co.",
    booth_size: "large",
    background_image: "/canvas/hazel/images/banner-3-placeholder.f720175f.jpg",
    image_url: "/canvas/hazel/images/logo-3-placeholder.3cfe0314.jpg",
    headline:
      "Acme is one of the world leaders in renewable energy solutions and a sponsor of The Future of Everything since day one.",
  },
  {
    id: 4,
    name: "Texon",
    booth_size: "large",
    background_image: "/canvas/hazel/images/banner-4-placeholder.b3c00905.jpg",
    image_url: "/canvas/hazel/images/logo-4-placeholder.d1f474d8.jpg",
    headline:
      "Texon works with organizations and governments all over the world to build and maintain sustainable food production systems.",
  },
  {
    id: 5,
    name: "Globex",
    booth_size: "large",
    background_image: "/canvas/hazel/images/banner-5-placeholder.e994fcfd.jpg",
    image_url: "/canvas/hazel/images/logo-5-placeholder.da5137be.jpg",
    headline:
      "Globex is the world’s leading expert in sustainable logistics: It’s helped hundreds of companies become completely carbon neutral.",
  },
  {
    id: 6,
    name: "Keyspace",
    booth_size: "large",
    background_image: "/canvas/hazel/images/banner-6-placeholder.64d89787.jpg",
    image_url: "/canvas/hazel/images/logo-6-placeholder.fae2771e.jpg",
    headline:
      "Keyspace is a top global research institute advocating for sustainable social and energy policies with governments and foundations worldwide.",
  },
];
